module.exports = __webpack_public_path__ + "static/media/front_detail.7cc5887a.png";